const data = {
	"width": 1024,
	"height": 1280,
	"body": "<path fill=\"currentColor\" d=\"M1024 448q0 26-19 45L557 941q-19 19-45 19t-45-19L19 493Q0 474 0 448t19-45t45-19h896q26 0 45 19t19 45z\"/>"
};
export default data;
